import Api from "shared/service/api/api";

export const LOAD_REFERRAL_INFO = "loadReferralInfo";
export const LOAD_PARTNERS_TABLE_DATA = "loadPartnersTableData";
export const LOAD_STATISTICS_TABLE_DATA = "loadStatisticsTableData";

export const SET_REFERRAL_INFO = "setReferralInfo";
export const SET_PARTNERS_TABLE_DATA = "setPartnersTableData";
export const SET_STATISTICS_TABLE_DATA = "setStatisticsTableData";

const state = {
  referralLink: "referral_link",
  totalProfit: 0,
  partnersTableData: [],
  statisticsTableData: [],
};

const actions = {
  [LOAD_REFERRAL_INFO]({ commit }) {
    return Api.collaboration.referral
      .info()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_REFERRAL_INFO, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_PARTNERS_TABLE_DATA]({ commit }) {
    return Api.collaboration.referral
      .partners()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_PARTNERS_TABLE_DATA, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_STATISTICS_TABLE_DATA]({ commit }, { id }) {
    return Api.collaboration.referral
      .statistics(id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_STATISTICS_TABLE_DATA, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_REFERRAL_INFO](state, { link, value }) {
    state.referralLink = link;
    state.totalProfit = value;
  },
  [SET_PARTNERS_TABLE_DATA](state, partners) {
    state.partnersTableData = partners;
  },
  [SET_STATISTICS_TABLE_DATA](state, partners) {
    state.statisticsTableData = partners;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
